<template>
    <ul class="componetntServices">
        <li v-for="item in ServicesData" :key="item.text">
            <div v-html="item.img">
            </div>
            <h4>{{item.title}}</h4>
            <p>Lorem ipsum dolor sit amet, consetetur
                sadipscing elitr, sed diam nonumy eirmod
                tempor</p>
            <router-link to="/services">Read More</router-link>
        </li>
    </ul>
</template>
<!-- 
       
        -->
<script>
    export default {
        name: "ServicesComponet",
        props: ['ServicesData'],
    }
</script>

<style scoped lang="scss" >
    .componetntServices {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        margin-left: 210px;
        margin-top: 75px;

        li {
            transition: all 0.5s;
            width: 423px;
            background-color: #fff;
            margin-right: 44.5px;
            margin-bottom: 45px;
            border-radius: 10px;
            z-index: 5;
            box-shadow: 0px 0px 15px 15px rgba(216, 216, 216, 0.102);
            position: relative;

            div {
                width: 91px;
                height: 91px;
                transition: all 0.5s;
                background-color: #49d6cb;
                border-radius: 50%;
                padding: 20px;
                margin: 0 auto;
                margin-top: 53px;
                z-index: 5;
                svg {
                    path {
                        transition: all 0.5s;
                    }
                }
            }

            h4 {
                font-size: 22px !important;
                font-family: "Comfortaa";
                transition: all 0.5s;
                letter-spacing: -0.40px;
                z-index: 5;
                margin-top: 34px;
                margin-left: 1px;
            }

            p {
                font-size: 16px !important;
                color: #c9c9c9 !important;
                transition: all 0.5s;
                max-width: 78% !important;
                z-index: 5;
                margin-top: -7px!important;
                line-height: 23px!important;
                padding-bottom: 30px;
                font-weight: bolder;
                font-family: "HelveticaNeueCyr";
            }

            a {
                display: inline-block;
                font-size: 16px !important;
                transition: all 0.5s;
                color: #49d6cb !important;
                z-index: 5;
                padding-bottom: 52px;
            }
        }

        li:before {
            position: absolute;
            content: "";
            width: 100%;
            height: 0%;
            transition: all 0.5s;
            z-index: -1;
            background: #49d6cb;
            border-radius: 10px;
            left: 0;
        }

        li:hover {
            div {
                background-color: #fff;

                svg path {
                    fill: #49d6cb !important;
                }
            }

            h4 {
                color: #fff;
            }

            p {
                color: #fff !important;
            }

            a {
                color: #fff !important;
            }
        }

        li:hover:before {
            height: 100%
        }
    }

    @media only screen and (max-width: 1900px) {
         .componetntServices {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-top: 75px;
            margin-left: 0;
        li {
            transition: all 0.5s;
            width: 340px;
            background-color: #fff;
            margin-right: 40px;
            margin-bottom: 40px;
            border-radius: 10px;
            z-index: 5;
            box-shadow: 0px 0px 15px 15px rgba(216, 216, 216, 0.102);
            position: relative;

            div {
                width: 91px;
                height: 91px;
                transition: all 0.5s;
                background-color: #49d6cb;
                border-radius: 50%;
                padding: 20px;
                margin: 0 auto;
                margin-top: 53px;
                z-index: 5;
                svg {
                    path {
                        transition: all 0.5s;
                    }
                }
            }

            h4 {
                font-size: 22px !important;
                font-family: "Comfortaa";
                transition: all 0.5s;
                letter-spacing: -0.40px;
                z-index: 5;
                margin-top: 34px;
                margin-left: 1px;
            }

            p {
                font-size: 16px !important;
                color: #c9c9c9 !important;
                transition: all 0.5s;
                max-width: 78% !important;
                z-index: 5;
                margin-top: -7px!important;
                line-height: 23px!important;
                padding-bottom: 30px;
                font-weight: bolder;
                font-family: "HelveticaNeueCyr";
            }

            a {
                display: inline-block;
                font-size: 16px !important;
                transition: all 0.5s;
                color: #49d6cb !important;
                z-index: 5;
                padding-bottom: 52px;
            }
        }

        li:before {
            position: absolute;
            content: "";
            width: 100%;
            height: 0%;
            transition: all 0.5s;
            z-index: -1;
            background: #49d6cb;
            border-radius: 10px;
            left: 0;
        }

        li:hover {
            div {
                background-color: #fff;

                svg path {
                    fill: #49d6cb !important;
                }
            }

            h4 {
                color: #fff;
            }

            p {
                color: #fff !important;
            }

            a {
                color: #fff !important;
            }
        }

        li:hover:before {
            height: 100%
        }
    }
    }

    @media only screen and (max-width: 1750px) {
        .componetntServices {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-top: 50px;

            li {
                transition: all 0.5s;
                width: 320px;
                background-color: #fff;
                margin: 20px;
                border-radius: 10px;
                z-index: 5;
                box-shadow: 0px 0px 15px 15px rgba(126, 126, 126, 0.10196078431372549);

                div {
                    width: 90px;
                    height: 90px;
                    background-color: #49d6cb;
                    border-radius: 50%;
                    padding: 20px;
                    margin: 0 auto;
                    margin-top: 50px;
                }

                h4 {
                    font-size: 24px;
                    font-family: "comfortaa";
                    margin-top: 30px;
                }

                p {
                    font-size: 16px;
                    color: #c9c9c9;
                    max-width: 80%;
                    padding-bottom: 20px;
                }

                a {
                    display: inline-block;
                    font-size: 16px;
                    color: #49d6cb;
                    padding-bottom: 50px;
                }
            }

            li:hover {

                div {
                    background-color: #fff;

                    svg path {
                        fill: #49d6cb;
                    }
                }

                h4 {
                    color: #fff;
                }

                p {
                    color: #fff;
                }

                a {
                    color: #fff;
                }
            }
        }
    }

    @media only screen and (max-width: 1500px) {
        .componetntServices {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-top: 50px;

            li {
                transition: all 0.5s;
                width: 320px;
                background-color: #fff;
                margin: 20px;
                border-radius: 10px;
                z-index: 5;
                box-shadow: 0px 0px 15px 15px rgba(126, 126, 126, 0.10196078431372549);

                div {
                    width: 90px;
                    height: 90px;
                    background-color: #49d6cb;
                    border-radius: 50%;
                    padding: 20px;
                    margin: 0 auto;
                    margin-top: 50px;
                }

                h4 {
                    font-size: 24px;
                    font-family: "comfortaa";
                    margin-top: 30px;
                }

                p {
                    font-size: 16px;
                    color: #c9c9c9;
                    max-width: 80%;
                    padding-bottom: 20px;
                }

                a {
                    display: inline-block;
                    font-size: 16px;
                    color: #49d6cb;
                    padding-bottom: 50px;
                }
            }

            li:hover {

                div {
                    background-color: #fff;

                    svg path {
                        fill: #49d6cb;
                    }
                }

                h4 {
                    color: #fff;
                }

                p {
                    color: #fff;
                }

                a {
                    color: #fff;
                }
            }
        }

    }

    @media only screen and (max-width: 1250px) {
        .componetntServices {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-top: 50px;

            li {
                transition: all 0.5s;
                width: 300px;
                background-color: #fff;
                margin: 20px;
                border-radius: 10px;
                z-index: 5;
                box-shadow: 0px 0px 15px 15px rgba(126, 126, 126, 0.10196078431372549);

                div {
                    width: 90px;
                    height: 90px;
                    background-color: #49d6cb;
                    border-radius: 50%;
                    padding: 20px;
                    margin: 0 auto;
                    margin-top: 50px;
                }

                h4 {
                    font-size: 24px;
                    font-family: "comfortaa";
                    margin-top: 30px;
                }

                p {
                    font-size: 16px;
                    color: #c9c9c9;
                    max-width: 80%;
                    padding-bottom: 20px;
                }

                a {
                    display: inline-block;
                    font-size: 16px;
                    color: #49d6cb;
                    padding-bottom: 50px;
                }
            }

            li:hover {

                div {
                    background-color: #fff;

                    svg path {
                        fill: #49d6cb;
                    }
                }

                h4 {
                    color: #fff;
                }

                p {
                    color: #fff;
                }

                a {
                    color: #fff;
                }
            }
        }
    }

    @media only screen and (max-width: 950px) {
        .componetntServices {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-top: 50px;

            li {
                transition: all 0.5s;
                width: 320px;
                background-color: #fff;
                margin: 20px;
                border-radius: 10px;
                z-index: 5;
                box-shadow: 0px 0px 15px 15px rgba(126, 126, 126, 0.10196078431372549);

                div {
                    width: 90px;
                    height: 90px;
                    background-color: #49d6cb;
                    border-radius: 50%;
                    padding: 20px;
                    margin: 0 auto;
                    margin-top: 50px;
                }

                h4 {
                    font-size: 24px;
                    font-family: "comfortaa";
                    margin-top: 30px;
                }

                p {
                    font-size: 16px;
                    color: #c9c9c9;
                    max-width: 80%;
                    padding-bottom: 20px;
                }

                a {
                    display: inline-block;
                    font-size: 16px;
                    color: #49d6cb;
                    padding-bottom: 50px;
                }
            }

            li:hover {

                div {
                    background-color: #fff;

                    svg path {
                        fill: #49d6cb;
                    }
                }

                h4 {
                    color: #fff;
                }

                p {
                    color: #fff;
                }

                a {
                    color: #fff;
                }
            }
        }

    }

    @media only screen and (max-width: 770px) {
        .componetntServices {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-top: 50px;

            li {
                transition: all 0.5s;
                width: 320px;
                background-color: #fff;
                margin: 20px;
                border-radius: 10px;
                z-index: 5;
                box-shadow: 0px 0px 15px 15px rgba(126, 126, 126, 0.10196078431372549);

                div {
                    width: 90px;
                    height: 90px;
                    background-color: #49d6cb;
                    border-radius: 50%;
                    padding: 20px;
                    margin: 0 auto;
                    margin-top: 50px;
                }

                h4 {
                    font-size: 24px;
                    font-family: "comfortaa";
                    margin-top: 30px;
                }

                p {
                    font-size: 16px;
                    color: #c9c9c9;
                    max-width: 80%;
                    padding-bottom: 20px;
                }

                a {
                    display: inline-block;
                    font-size: 16px;
                    color: #49d6cb;
                    padding-bottom: 50px;
                }
            }

            li:hover {

                div {
                    background-color: #fff;

                    svg path {
                        fill: #49d6cb;
                    }
                }

                h4 {
                    color: #fff;
                }

                p {
                    color: #fff;
                }

                a {
                    color: #fff;
                }
            }
        }
    }

    @media only screen and (max-width: 430px) {

        .componetntServices {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-top: 50px;

            li {
                transition: all 0.5s;
                width: 280px;
                background-color: #fff;
                margin: 10px;
                border-radius: 10px;
                z-index: 5;
                box-shadow: 0px 0px 15px 15px rgba(126, 126, 126, 0.10196078431372549);

                div {
                    width: 90px;
                    height: 90px;
                    background-color: #49d6cb;
                    border-radius: 50%;
                    padding: 20px;
                    margin: 0 auto;
                    margin-top: 20px;
                }

                h4 {
                    font-size: 20px!important;
                    font-family: "comfortaa";
                    margin-top: 20px;
                }

                p {
                    font-size: 12px!important;
                    color: #c9c9c9;
                    max-width: 80%;
                    padding-bottom: 20px;
                }

                a {
                    display: inline-block;
                    font-size: 16px;
                    color: #49d6cb;
                    padding-bottom: 20px;
                }
            }

            li:hover {

                div {
                    background-color: #fff;

                    svg path {
                        fill: #49d6cb;
                    }
                }

                h4 {
                    color: #fff;
                }

                p {
                    color: #fff;
                }

                a {
                    color: #fff;
                }
            }
        }
    }
</style>